import React, { useContext } from "react";

import { IUser } from "../../../../types";

export const UserContext = React.createContext<IUser | null>(null);

export const useUserContext = () => useContext(UserContext);

// Hands a saved customer back to the page that loaded it (UserSearch), so
// every view under it shows the saved data, also after a route change.
export const UpdateUserContext = React.createContext<(user: IUser) => void>(
  () => {}
);

export const useUpdateUserContext = () => useContext(UpdateUserContext);
